import { createOAuthConfig } from '@aecom-ai-engineering/auth';
export function isPdeEnvironment() {
    if (typeof window === 'undefined') {
        return false;
    }
    const hostname = window.location.hostname;
    // PDE environments use their generated Azure Static Web Apps hostnames;
    // stable environments use custom domains.
    return hostname.endsWith('.azurestaticapps.net');
}
export const createOAuthConfiguration = ({ webappClientId, oauthEndpoint, webappUrl, redirectUri, }) => {
    // Extract tenant name from OAuth endpoint
    const tenantMatch = oauthEndpoint.match(/\/([^/]+)\.onmicrosoft\.com/);
    const tenantName = tenantMatch ? tenantMatch[1] : 'consiglisaas';
    // Extract policy name from OAuth endpoint
    const policyMatch = oauthEndpoint.match(/\/(B2C_[^/]+)$/);
    const policyName = policyMatch ? policyMatch[1] : 'B2C_1A_SIGNINLOCALANDMICROSOFT';
    // Extract custom domain
    const customDomain = new URL(oauthEndpoint).hostname;
    // Use explicit redirectUri if provided (for PDEs with relay pattern)
    // Otherwise derive it from webappUrl
    const finalRedirectUri = redirectUri || `${webappUrl}/auth`;
    return createOAuthConfig({
        tenantName,
        policyName,
        clientId: webappClientId,
        customDomain,
        redirectUri: finalRedirectUri,
        logoutUri: `${webappUrl}/logout`,
    });
};
